import fetcher from 'api/fetcher';
import { isValidAreaId } from 'utils/campaign';
import { EMPTY_ARRAY } from 'utils/clickme';
import { DUMMY_VACANCY } from 'utils/constants/campaign';

import { Action } from 'store/createReducer';
import { setBannerDefaultText } from 'store/models/bannerTextGeneration';
import {
    setBannerLink,
    setBannerText,
    setBannerTitle,
    setBannerVacancyId,
    setVacancyName,
} from 'store/models/createBanner';
import { setCampaignProfessions, setCampaignRegions } from 'store/models/createCampaign';
import { AppThunkAction } from 'store/utils';

interface BannerVacancyResponse {
    title: string;
    text: string;
    url: string;
    areaId: number;
    profRoleIds: number[];
}

export const fetchBannerByVacancy = (vacancyId: number, isCopying: boolean): AppThunkAction<void> => {
    return (dispatch) => {
        if (vacancyId === DUMMY_VACANCY) {
            const actions: Action[] = [];

            if (!isCopying) actions.push(setCampaignProfessions(EMPTY_ARRAY), setCampaignRegions(EMPTY_ARRAY));

            dispatch(actions);
            return;
        }

        void fetcher
            .get<unknown, BannerVacancyResponse>(`/api/v1/vacancy/campaign_info_from_vacancy/?vacancyId=${vacancyId}`)
            .then((banner) => {
                const { title, text, url, areaId, profRoleIds } = banner;
                const actions: Action[] = [setBannerVacancyId(vacancyId), setBannerLink(url), setVacancyName(title)];

                if (isCopying) {
                    dispatch(actions);
                    return;
                }

                actions.push(
                    setBannerTitle(title),
                    setBannerText(text),
                    setCampaignProfessions(profRoleIds.map(String)),
                    setBannerDefaultText(text),
                    setVacancyName(title)
                );

                if (isValidAreaId(areaId)) {
                    const newRegions = [String(areaId)];
                    actions.push(setCampaignRegions(newRegions));
                }

                dispatch(actions);
            });
    };
};
